import React, { useState, useEffect, useRef } from 'react'
import Login from '@react-login-page/page9';
import './Home.css';
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import { Link } from "react-router-dom";
import { environment } from '../environment/production';
import ReCAPTCHA from "react-google-recaptcha";


function Home() {
  const [apiCall, setApiCall] = useState(0)
  const recaptchaRef = React.createRef();
  const navigate = useNavigate();
  const [recaptcha,setReCaptcha]=useState('')
  const [formdata, setFormData] = useState({
    email: '',
    password: '',
    // re_captcha:''
  });
  const [errorMsg,setErrorMsg]=useState(
    {
      email: '',
    password: '',
    re_captcha:''
  }
  )
 
  const options={
    data:{
      formdata
    },
    headers:{
      'Content-type':'application/json',
    }
  }
  useEffect(() => {
    if (apiCall == 0) {
      sessionStorage.removeItem("access_token");
      sessionStorage.removeItem("user_id");
      sessionStorage.removeItem("email_id")
      sessionStorage.removeItem("mobile_no")
      sessionStorage.removeItem("first_name")
      sessionStorage.removeItem("middle_name")
      sessionStorage.removeItem("last_name")
      sessionStorage.removeItem("reference_id")
    }
    setApiCall(1)
  }, [apiCall])
  const handleValidation=(e)=>{
    
    // e.preventDefault();
    // console.log(JSON.stringify(options.data.formdata));
    // navigate("/registration")

    // && formdata.re_captcha==''
    if(formdata.email =='' && formdata.password =='' ){
      setErrorMsg({email:'Email is required',password:'Password is required',re_captcha:'Captcha is required'})
    }else{
    
   if( formdata.email ==''){
   // alert("Email is required")
   setErrorMsg({email:'Email is required'})
   }else if(formdata.password ==''){
    // alert("Password is required")
    setErrorMsg({password:'Password is required'})
   }
   else if(recaptcha==''){
    setErrorMsg({re_captcha:'Captcha is required'})
  }
     
  }
 
   if(formdata.email !=='' && formdata.password !=='' && recaptcha!==''){
       axios.post(environment.apiUrl+`/User/login`,JSON.stringify(options.data.formdata),{headers:JSON.stringify(options.headers)})
 .then((response)=>{
  if(response['data']['status']=="1"){
  if(response.data.data.reference_id=="NA"){
      sessionStorage.setItem("access_token",response.data.access_token)
      sessionStorage.setItem("user_id",response.data.data.id)
      sessionStorage.setItem("email_id",response.data.data.email_id)
      sessionStorage.setItem("mobile_no",response.data.data.mobile_number)
      sessionStorage.setItem("first_name",response.data.data.first_name)
      sessionStorage.setItem("middle_name",response.data.data.middle_name)
      sessionStorage.setItem("last_name",response.data.data.last_name)
      navigate("/registration")
    }
 else{
      sessionStorage.setItem("access_token",response.data.access_token)
      sessionStorage.setItem("user_id",response.data.data.id)
      sessionStorage.setItem("email_id",response.data.data.email_id)
      sessionStorage.setItem("mobile_no",response.data.data.mobile_number)
      sessionStorage.setItem("first_name",response.data.data.first_name)
      sessionStorage.setItem("middle_name",response.data.data.middle_name)
      sessionStorage.setItem("last_name",response.data.data.last_name)
      navigate("/user-dashboard")
    }
    
  }else{
    //alert(response['data']['msg'])
    setErrorMsg({wrongLogin:response['data']['msg']})
    navigate("/login")
  }
 })
   }
}
const handleSubmit = (e) => {
e.preventDefault();
//console.log(e.target.appl_recvd_d.value);
formdata.email=e.target.email.value;
formdata.password=e.target.password.value;


setFormData(...[formdata]);

/* axios api post */
handleValidation();

};

  function register(e) { 
      e.preventDefault(); 
     // if(e.target.email.value && e.target.password.value){
        navigate("/registration-close")
     // }
  } 
  function forgotPassword(){
    navigate("/forgot-password")
  }
  return (
    <>
    
     <div className="login-page login-page9">
        {/* style={{ backgroundImage: `url('./gstn.png')` }} */}
     <div className="login-page9-wrapper">
      
     <div style={{color:'red',textAlign:'center'}}>{errorMsg.wrongLogin}</div> 
     <h5 className="text-center">GSTAT Deputation Application Portal</h5>
      <form action="" onSubmit={handleSubmit}>
      
          <header> 
            <h1>LOGIN</h1>
          </header>
          
          <br/>
          <span style={{color:'red'}}>{errorMsg.email}</span>
          <label className="rlp-username">
            <input placeholder="Email" index="1" name="email" />
          </label>
          <span style={{color:'red'}}>{errorMsg.password}</span>
          <label className="rlp-password">
          <input type="password" placeholder="Password" index="2" name="password" />
          </label>
          <span style={{color:'red'}}>{errorMsg.re_captcha}</span>
          <div className="re-captcha">
          <ReCAPTCHA ref={recaptchaRef} sitekey={environment.recaptcha.siteKey} name="re_captcha" onChange={(value)=>setReCaptcha(value)} />
          </div>
          <section>
          
          <button type="submit">Submit</button></section>
         
      </form>
      
      <div className="buttons" style={{display:'flex',justifyContent:'space-between'}}>
      <button type="submit" onClick={register} style={{width:'30%'}}>Register</button>
      <button type="submit" onClick={forgotPassword} style={{width:'40%'}}>Forgot Password</button>
      </div>
     
      </div>
    </div>
    </>
  );
}

export default Home;